////////////////QuestionType.js

import { $AjaxJson } from '@/lf'
import { $Urlpath, $UrlApipath } from '@/config/config'
export const QuestionTypeRequest = {

    GetQuestionType(func, ID) {
        $AjaxJson($UrlApipath + "System/GetQuestionType", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddQuestionType(func, obj) {
        $AjaxJson($UrlApipath + "System/AddQuestionType", obj, function (d) {
            func(d)
        })
    },
    UpdateQuestionType(func, obj) {
        $AjaxJson($UrlApipath + "System/UpdateQuestionType", obj, function (d) {
            func(d)
        })
    },
    SearchQuestionType(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchQuestionType", obj, function (d) {
            func(d)
        })
    },
    SearchQuestionTypeList(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchQuestionTypeList", obj, function (d) {
            func(d)
        })
    },
    DeleteQuestionType(func, ID) {
        $AjaxJson($UrlApipath + "System/DeleteQuestionType", { ID: ID }, function (d) {
            func(d)
        })
    },

}

////////////////QuestionType.js End ///////////////////



export const QuestionRequest = {

    GetQuestion(func, ID) {
        $AjaxJson($UrlApipath + "System/GetQuestion", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddQuestion(func, obj) {
        $AjaxJson($UrlApipath + "System/AddQuestion", obj, function (d) {
            func(d)
        })
    },
    UpdateQuestion(func, obj) {
        $AjaxJson($UrlApipath + "System/UpdateQuestion", obj, function (d) {
            func(d)
        })
    },
    SearchQuestion(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchQuestion", obj, function (d) {
            func(d)
        })
    },
    SearchQuestionList(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchQuestionList", obj, function (d) {
            func(d)
        })
    },
    DeleteQuestion(func, ID) {
        $AjaxJson($UrlApipath + "System/DeleteQuestion", { ID: ID }, function (d) {
            func(d)
        })
    },

    SetQuestionPriorityLevel(func, ID, PriorityLevel) {
        $AjaxJson($UrlApipath + "System/SetQuestionPriorityLevel", { ID: ID, PriorityLevel: PriorityLevel }, function (d) {
            func(d)
        })
    },
    
    SetQuestionCustomerRead(func, ID, CustomerRead) {
        $AjaxJson($UrlApipath + "System/SetQuestionCustomerRead", { ID: ID, CustomerRead: CustomerRead }, function (d) {
            func(d)
        })
    },
    SetQuestionSystemRead(func, ID, SystemRead) {
        $AjaxJson($UrlApipath + "System/SetQuestionSystemRead", { ID: ID, SystemRead: SystemRead }, function (d) {
            func(d)
        })
    },
   
    ApplyQuestion(func, ID) {
        $AjaxJson($UrlApipath + "System/ApplyQuestion", { ID: ID }, function (d) {
            func(d)
        })
    },


    
    TransferQuestion(func, ID, TransferUserID) {
        $AjaxJson($UrlApipath + "System/TransferQuestion", { ID: ID, TransferUserID: TransferUserID }, function (d) {
            func(d)
        })
    },
   
    QuestionProcess(func, ID, NextUserID,Comment) {
        $AjaxJson($UrlApipath + "System/QuestionProcess", { ID: ID, NextUserID: NextUserID,Comment:Comment }, function (d) {
            func(d)
        })
    },
   
    CompleteQuestion(func, ID) {
        $AjaxJson($UrlApipath + "System/CompleteQuestion", { ID: ID}, function (d) {
            func(d)
        })
    },
   
    SetQuestionPriorityLevels(func, IDs, PriorityLevel) {
        $AjaxJson($UrlApipath + "System/SetQuestionPriorityLevels", { IDs: IDs, PriorityLevel: PriorityLevel }, function (d) {
            func(d)
        })
    },
   
    SetQuestionRemark(func, ID, Remark) {
        $AjaxJson($UrlApipath + "System/SetQuestionRemark", { ID: ID, Remark: Remark }, function (d) {
            func(d)
        })
    },
   
    AddQuestionContent(func, obj) {
        $AjaxJson($UrlApipath + "System/AddQuestionContent",obj, function (d) {
            func(d)
        })
    },
    
}




// WEBPACK FOOTER //
// ./src/request/Question.js